<!--Start Back To Top Button-->
<a href="#" (click)="$event.preventDefault()" class="back-to-top"><i class='bx bxs-up-arrow-alt'></i></a>
<!--End Back To Top Button-->
<!--footer -->
<div class="footer">
	<p class="mb-0">Data Convergence &copy; 2022</p>
</div>
<!-- end footer -->
